import { Facet } from "@/shared/facets/facets.model";

/**
 * Generates the aggregation part of a GraphQL query based on facet.
 * Supports field, metadata, and keyword aggregations.
 *
 * @param facet - The facet
 * @param keywordSearchValue - Optional search prefix for keyword aggregations
 * @returns GraphQL query string for aggregations or empty string
 */
export const generateAggregationQueryPart = (facet: Facet, keywordSearchValue: string = ""): string => {
    const keywordAggregation = facet.facetType === "keyword";
    const metaDataAggregation = facet.type === "metadata" && facet.facetType !== "keyword";
    const fieldAggregation = facet.type === "field" && facet.facetType !== "keyword";

    if (!metaDataAggregation && !fieldAggregation && !keywordAggregation) {
        return "";
    }

    const standardPagination = `(after: "", first: 1000) {
                count
                value
            }`;

    const keywordPagination = `(first: 100, prefix: "${keywordSearchValue}") {
                        count
                        value
                    }`;

    const parts: string[] = [];

    if (fieldAggregation) {
        parts.push(`${facet.id}${standardPagination}`);
    }

    if (metaDataAggregation) {
        parts.push(`useContext {
                composite {
                    ${facet.id}${standardPagination}
                }
            }`);
    }

    if (keywordAggregation) {
        parts.push(`useContext {
                terms {
                    ${facet.id}${keywordPagination}
                }
            }`);
    }

    return `aggregations {
            ${parts.join("\n")}
        }`;
};
